<div class="modal  fade" id="{{nome}}" tabindex="-1" role="dialog" aria-hidden="true" (mousedown)="alterVisualizar(false, true)" >
  <div class="modal-dialog {{modal}} modal-dialog-centered" role="document" (mousedown)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header {{styleClassHeader}}">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">{{titulo}}</h5>
        <button type="button" class="close"  aria-label="Close" (click)="alterVisualizar(false, true)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [style]="styleBody">
        <ng-content></ng-content>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-secondary btn-sm text-white float-left"
          (click)="alterVisualizar(false, true)">Cancelar</button>
        <div>
          <ng-content select="[opcoes]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>